/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService
 */
import * as References from './ReplyRecommendationsSettingsService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#updateSettingsV2
 */
export const UPDATE_SETTINGS_V2_MUTATION_FIELD_NAME =
  'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_updateSettingsV2';
export const UPDATE_SETTINGS_V2_MUTATION: RegisteredQuery<
  'result',
  References.UpdateSettingsV2RequestType,
  References.UpdateSettingsV2ResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_SETTINGS_V2_MUTATION_FIELD_NAME,
  args: ['isEnabled', 'aiAgentUserId', 'lastUpdatedAt'],
  fetcher(
    request: References.UpdateSettingsV2RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateSettingsV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateSettingsV2Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#getSettings
 */
export const GET_SETTINGS_QUERY_FIELD_NAME =
  'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_getSettings';
export const GET_SETTINGS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetSettingsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SETTINGS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSettingsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getSettingsRpc, {
      timeout: ctx.timeout,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#getSettingsV2
 */
export const GET_SETTINGS_V2_QUERY_FIELD_NAME =
  'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_getSettingsV2';
export const GET_SETTINGS_V2_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetSettingsV2ResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SETTINGS_V2_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSettingsV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getSettingsV2Rpc, {
      timeout: ctx.timeout,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService#areReplyRecsEnabled
 */
export const ARE_REPLY_RECS_ENABLED_QUERY_FIELD_NAME =
  'com_hubspot_cv_replies_rpc_ReplyRecommendationsSettingsService_areReplyRecsEnabled';
export const ARE_REPLY_RECS_ENABLED_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.AreReplyRecsEnabledResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: ARE_REPLY_RECS_ENABLED_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.AreReplyRecsEnabledResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.areReplyRecsEnabledRpc,
      { timeout: ctx.timeout }
    );
  },
});
